'use client';
import { createContext } from 'react';
export const AppLayoutContext = createContext(undefined);
AppLayoutContext.displayName = 'AppLayoutContext';
//# sourceMappingURL=AppLayoutContext.js.map